import * as React from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";
import { useAuth } from "@providers/auth";

function NavbarUserDropdown() {
  const navigate = useNavigate();
  const auth = useAuth();
  const signOut = auth.logout;

  const handleSignOut = async () => {
    await signOut();
    navigate("/auth/sign-in");
  };

  return (
    <Button
      variant="outlined"
      color="inherit"
      onClick={handleSignOut}
      size="small"
    >
      Logout
    </Button>
  );
}

export default NavbarUserDropdown;
